(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["dafodila-highlights"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('dafodila-highlights')) {
    customElements.define(
      'dafodila-highlights',
      class extends HTMLElement {
        connectedCallback() {
          this.dialog = this.querySelector('.dhl__dialog');
          this.chips = Array.from(this.querySelectorAll('.dhl__chip'));
          this.panels = Array.from(this.querySelectorAll('.dhl__panel'));

          this.querySelectorAll('.dhl__card').forEach((card) => {
            card.addEventListener('click', () => this.open(Number(card.dataset.index), card));
          });

          this.chips.forEach((chip) => {
            chip.addEventListener('click', () => this.select(Number(chip.dataset.index)));
            chip.addEventListener('keydown', (e) => this.onChipKey(e));
          });

          if (this.dialog) {
            this.querySelector('.dhl__close')?.addEventListener('click', () => this.dialog.close());
            this.dialog.addEventListener('click', (e) => {
              if (e.target === this.dialog) this.dialog.close();
            });
            this.dialog.addEventListener('close', () => this.trigger?.focus());
          }

          const sw = this.querySelector('.dhl__switch');
          const list = this.querySelector('.dhl__ings');
          const setView = (on) => {
            sw?.setAttribute('aria-checked', String(on));
            if (list) list.dataset.view = on ? 'list' : 'grid';
          };
          sw?.addEventListener('click', () => setView(sw.getAttribute('aria-checked') !== 'true'));

          // Tapping an ingredient turns "How they help" on and briefly highlights that ingredient
          this.querySelectorAll('.dhl__ing-btn').forEach((btn) => {
            btn.addEventListener('click', () => {
              if (list?.dataset.view !== 'list') setView(true);
              const item = btn.closest('.dhl__ing');
              item.classList.remove('is-flash');
              void item.offsetWidth;
              item.classList.add('is-flash');
              item.addEventListener('animationend', () => item.classList.remove('is-flash'), { once: true });
              item.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
            });
          });
        }

        open(index, trigger) {
          if (!this.dialog) return;
          this.trigger = trigger;
          this.select(index, false);
          if (!this.dialog.open) this.dialog.showModal();
          this.chips[index]?.focus({ preventScroll: true });
          this.chips[index]?.scrollIntoView({ block: 'nearest', inline: 'center' });
        }

        select(index, focus = true) {
          this.chips.forEach((chip, i) => {
            const active = i === index;
            chip.setAttribute('aria-selected', String(active));
            chip.tabIndex = active ? 0 : -1;
          });
          this.panels.forEach((panel, i) => {
            panel.hidden = i !== index;
          });
          if (focus) this.chips[index]?.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        }

        onChipKey(e) {
          const current = this.chips.indexOf(e.currentTarget);
          let next = null;
          if (e.key === 'ArrowRight') next = (current + 1) % this.chips.length;
          if (e.key === 'ArrowLeft') next = (current - 1 + this.chips.length) % this.chips.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = this.chips.length - 1;
          if (next === null) return;
          e.preventDefault();
          this.select(next);
          this.chips[next].focus();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
